export const RETENTION_THROTTLE_MS = 15 * 60 * 1000;

const ADD_LOG_TYPES = ["wellness", "training", "recovery", "niggle"] as const;

export type AddLogParam = (typeof ADD_LOG_TYPES)[number];

/** Log type for a `?addLog=` deep link (banner buttons and push urls), or null. */
export function parseAddLogParam(value: string | null): AddLogParam | null {
  return ADD_LOG_TYPES.find((type) => type === value) ?? null;
}

/**
 * Returns a check that allows at most one call per key within `intervalMs`.
 * Each allowed call starts a new interval for that key.
 */
export function createThrottle(
  intervalMs: number,
  now: () => number = Date.now,
): (key: string) => boolean {
  const lastAllowed = new Map<string, number>();
  return (key) => {
    const nowMs = now();
    const last = lastAllowed.get(key);
    if (last !== undefined && nowMs - last < intervalMs) return false;
    lastAllowed.set(key, nowMs);
    return true;
  };
}

/** Paths of the Data / insights screens that count as viewing insights. */
export function isInsightsPath(pathname: string): boolean {
  return (
    pathname.startsWith("/insights/") ||
    pathname === "/dailyreport" ||
    pathname === "/cycle"
  );
}
